// @ts-nocheck
import React, { useState, useRef, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import api, { contractsApi, pendingInvoicesApi, xeroApi } from '../services/api';
import {
  ContractDetailsCard,
  ShipmentDetailsCard,
  BookingDetailsCard,
  CommissionMarginCard,
  ContractCommissionCard,
  PaymentHistoryCard,
  PaymentTrackingCard,
  QuickActionsCard,
  TrackingCard,
  DocumentsCard,
  ExtendedContractDetails,
  BookingDetailsData,
  CommissionMarginData,
  ContractCommissionData,
  PaymentHistoryData,
  QuickActionButton,
  TrackingData,
  DocumentsData,
  BookingManagementModal
} from '../components/contract';
import { BookingRequestModal } from '../components/contract/BookingRequestModal';
import { ShippingInstructionModal } from '../components/contract/ShippingInstructionModal';
import { ContractEmailModal } from '../components/contract/ContractEmailModal';
import { PrintModal } from '../components/modals/PrintModal';
import { message, Modal, Button } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FinancialFormatter } from '../components/contract/FinancialFormatting';
import { Title, Typography } from '../components/design-system/typography';
import { colors, spacing } from '../components/design-system/tokens';
import { parseContractReference } from '../utils/contractReference';
import FindVesselModal from '../components/vessel/FindVesselModal';
import { max, subDays, startOfToday, differenceInDays } from 'date-fns';
import { transformContainerEventsToTrackingData } from '../components/contract/utils/trackingUtils';

// Sample contract data matching the Figma design
const sampleContract: ExtendedContractDetails = {
  id: 'CR-CA25876',
  reference: 'CR-CA25876',
  generalInfo: {
    contractDate: '28 February 2025',
    buyerRef: '51-0214',
    sellerRef: 'SH1024D',
    revisionDate: '05 March 2025',
    buyerSigned: '06 March 2025',
    sellerSigned: '05 March 2025',
  },
  parties: {
    supplier: {
      name: 'Treehouse California Almonds, LLC',
      address: {
        street: '6914 Road 160',
        city: 'Earlimart',
        state: 'CA',
        postalCode: '93219',
        country: 'United States'
      }
    },
    seller: {
      name: 'Rimtrade, LLC',
      address: {
        street: '2108 N St, Ste N #8163',
        city: 'Sacramento',
        state: 'CA',
        postalCode: '95816',
        country: 'United States'
      }
    },
    buyer: {
      name: 'Shinyei Kaisha',
      address: {
        street: '77-1 Kyomachi Chuo-ku',
        city: 'Kobe',
        postalCode: '651-0178',
        country: 'Japan'
      }
    },
    brand: 'Treehouse'
  },
  paymentInfo: {
    sellerTerms: 'TT on Faxed Documents',
    buyerTerms: 'TT on Faxed Documents',
    sellerBasis: 'FAS Oakland',
    buyerBasis: 'FAS Oakland',
  },
  notes: {
    sellerNotes: "Japan Quality. Buyer's call. Japanese label. Shinyei# TBA",
    buyerNotes: "Japan Quality. Buyer's call. Japanese label. Shinyei# TBA",
  },
  shipments: [
    {
      id: 'shipment-1',
      shipmentNumber: '1',
      timing: {
        shipment: 'LH Jun \'25',
        shipsWith: 'CR-BR2406901',
        packingNotes: 'Marks: Product description, Lot no., Pack date, Japanese label (with pack date, Shinyei#).',
        note1: 'Note 1: It is your responsibility to instruct your driver to choose a clean food grade container. Before accepting a container it should be inspected for sanitation problems, odors, punctures that could cause water leaks, or other damage.',
        note2: 'Note 2: Due to ongoing port congestion, terminal conditions may change quickly which affect your ability to pick up or return equipment. Dates are for reference only, and subject to change without notice; customers and truckers must verify with respective terminals before actual container pick up and return dates. Any cost your account.'
      },
      booking: {
        bookingBy: 'Shipper',
        fclTruck: 'FCL',
        siAttnTo: 'Ancelma Sanchez, Shipping Department',
        forwarder: 'Castle Forwarding',
        trucking: 'Seller\'s choice'
      },
      notes: {
        sellerNotes: "Japan Quality. Buyer's call. Japanese label. Shinyei# TBA",
        buyerNotes: "Japan Quality. Buyer's call. Japanese label. Shinyei# TBA"
      },
      containers: [
        {
          id: 'container-1-1',
          containerNumber: '1.1',
          details: {
            containerNumber: 'ONEU321654987',
            sealNumber: '3126978654',
            grossWeight: {
              lbs: '44,000 lbs',
              kg: '19,958.1 kg'
            },
            netWeight: {
              lbs: '47,259 lbs',
              kg: '21,436.3 kg'
            },
            equipment: '40ft'
          },
          goods: [
            {
              id: 'goods-1-1-1',
              goodsNumber: '1.1.1',
              details: {
                commodity: 'California Shelled Almonds, 2024 crop',
                goods: 'Nonpareil US Extra No. 1 (J-spec) 23/25',
                price: '3.050',
                units: '880',
                lbsEa: '50',
                unit: 'cases',
                documents: 'Almonds: Invoice, Packing List, Quality Cert, including Moisture%, Phytosanitary Report, Certificate of Origin, Fumigation Statement, COA showing that goods have been tested per the Protocol for the Control of Aflatoxin in U.S. Almonds being Exported to Japan. Stating crop year: 2024 (USA and Japan-approved laboratory), COA for Salmonella compliance, Weight Cert., Truck B/L, and others customary for Japan. Goods are for further processing. Goods to conform to Japanese Foods Sanitation Act.'
              }
            }
          ]
        }
      ]
    }
  ],
  booking: {
    bookingNumber: '1',
    carrier: 'Ocean Network Express (ONE)',
    bookingDate: '23 May 2025',
    vesselVoy: 'MOL CREATION / 096W',
    bookingRef: 'RICFY4044900',
    portOfLoading: 'Oakland',
    portOfDelivery: 'Tokyo',
    docsCutoff: '26 June 2025',
    cyCut: '30 June 2025',
    etd: '03 July 2025',
    eta: '15 July 25',
    specialInstructions: '*** Japan PEC program COA for Aflatoxin and proper documents required. ***RIMTRADE LLC is shipper of record, please note for documents. RIMTRADE LLC, 2108 N St, Ste N #8163, Sacramento CA 95816',
    containerPickup: {
      facility: 'OICT (Oakland International Container Terminal)',
      address: ['1999 Middle Harbor Rd', 'Oakland CA']
    },
    containerDropoff: {
      facility: 'Trapac, Inc. (Y549)',
      address: ['2800 7th St, Berth 30', 'Oakland CA 94607']
    },
    sendDocsTo: 'Buyer following Telex Release of container (original OBL not required).'
  },
  commissionRate: 2.0, // 2.0% commission rate at contract level
  contractCommission: {
    commissionRate: 2.0,
    marginShare: 50.0,
    totalCommission: 4716.00
  },
  commission: {
    commissionRate: 2.0,
    commissionShare: 50.0,
    shipments: [
      {
        shipmentNumber: '1',
        commissionAmount: 2450.00, // Will be calculated based on goods
        expenses: 92.00,
        status: 'invoiced'
      }
    ]
  },
  paymentHistory: {
    payments: [
      {
        id: 'payment-1',
        date: '24 MAR 2025',
        amount: 98992.50,
        type: 'wire',
        description: 'Initial payment from buyer'
      },
      {
        id: 'payment-2', 
        date: '24 MAR 2025',
        amount: -97020.00,
        type: 'wire',
        description: 'Payment to supplier'
      }
    ],
    totalCommission: 1972.50
  },
  documents: {
    sections: [
      {
        title: 'Contract Documents',
        documents: [
          {
            id: 'doc-1',
            title: 'Signed Contract',
            type: 'other',
            status: 'complete',
            date: '2025-03-06',
            fileSize: '2.4 MB'
          },
          {
            id: 'doc-2',
            title: 'Amendment #1',
            type: 'other',
            status: 'pending',
            date: '2025-03-08'
          }
        ]
      },
      {
        title: 'Shipping Documents',
        documents: [
          {
            id: 'doc-3',
            title: 'Bill of Lading',
            type: 'bill-of-lading',
            status: 'complete',
            date: '2025-06-10',
            fileSize: '1.2 MB'
          },
          {
            id: 'doc-4',
            title: 'Packing List',
            type: 'packing-list',
            status: 'complete',
            date: '2025-06-10',
            fileSize: '890 KB'
          },
          {
            id: 'doc-5',
            title: 'Certificate of Origin',
            type: 'certificate',
            status: 'complete',
            date: '2025-06-09',
            fileSize: '654 KB'
          },
          {
            id: 'doc-6',
            title: 'Quality Certificate',
            type: 'certificate',
            status: 'missing'
          }
        ]
      },
      {
        title: 'Financial Documents',
        documents: [
          {
            id: 'doc-7',
            title: 'Commercial Invoice',
            type: 'invoice',
            status: 'draft',
            date: '2025-06-12'
          },
          {
            id: 'doc-8',
            title: 'Insurance Certificate',
            type: 'certificate',
            status: 'pending',
            date: '2025-06-11'
          }
        ]
      }
    ],
    lastUpdated: '2 hours ago',
    totalDocuments: 8,
    completedDocuments: 4
  }
};

const ContractReview: React.FC = () => {
  const { reference } = useParams<{ reference: string }>();
  const [downloadingPDF, setDownloadingPDF] = React.useState<string | null>(null);
  const [bookingRequestModalOpen, setBookingRequestModalOpen] = useState(false);
  const [findVesselModalOpen, setFindVesselModalOpen] = useState(false);
  const [selectedShipmentForVessel, setSelectedShipmentForVessel] = useState<any>(null);
  const [siModalOpen, setSiModalOpen] = useState(false);
  const [selectedShipmentId, setSelectedShipmentId] = useState<string | null>(null);
  const [contractEmailModalOpen, setContractEmailModalOpen] = useState(false);
  const [printModalOpen, setPrintModalOpen] = useState(false);
  const [contractEmailAudience, setContractEmailAudience] = useState<'buyer' | 'supplier'>('buyer');
  const [bookingModalOpen, setBookingModalOpen] = useState(false);
  const [editingBookingId, setEditingBookingId] = useState<string | null>(null);
  const [editingBookingData, setEditingBookingData] = useState<any>(null);
  const [editingShipmentData, setEditingShipmentData] = useState<any>(null);
  const [editingContractId, setEditingContractId] = useState<string | null>(null);
  const [editingShipmentId, setEditingShipmentId] = useState<string | null>(null);
  const [duplicating, setDuplicating] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  /**
   * Shipment Filtering Feature:
   * 
   * This component supports viewing either all shipments for a contract or a single shipment.
   * The URL format determines the behavior:
   * 
   * - /contracts/CR-CA25479 → Shows all shipments for contract CR-CA25479
   * - /contracts/CR-CA25479.01 → Shows only shipment .01, with auto-scroll and highlight
   * 
   * When a shipment number is specified (.01, .02, etc.):
   * 1. Only that shipment is displayed (filtering)
   * 2. The page auto-scrolls to the shipment section
   * 3. The shipment is visually highlighted with a border
   * 4. If the shipment is not found, a helpful error message is shown
   */
  
  // Parse the reference to extract contract reference and optional shipment number
  const { contractRef, shipmentNumber } = parseContractReference(reference || '');

  // Ref for auto-scrolling to the selected shipment
  const selectedShipmentRef = useRef<HTMLDivElement>(null);

  // Fetch contract data from API using the base contract reference (without shipment suffix)
  const { data: contractData, isLoading, error } = useQuery({
    queryKey: ['contract', contractRef],
    queryFn: () => contractsApi.getContract(contractRef),
    enabled: !!contractRef,
  });

  // Auto-scroll to selected shipment when data loads
  useEffect(() => {
    if (shipmentNumber && contractData && selectedShipmentRef.current) {
      // Small delay to ensure DOM is fully rendered
      setTimeout(() => {
        selectedShipmentRef.current?.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });
      }, 100);
    }
  }, [shipmentNumber, contractData]);

  // Fetch pending invoice status for all shipments
  const shipmentIds = contractData?.shipments?.map(s => s.id) || [];
  const pendingInvoiceQueries = useQuery({
    queryKey: ['pending-invoices-by-shipments', shipmentIds],
    queryFn: () => pendingInvoicesApi.getByShipments(shipmentIds),
    enabled: shipmentIds.length > 0,
  });

  // Remove booking mutation
  const removeBookingMutation = useMutation({
    mutationFn: async (shipmentId: string) => {
      const response = await api.delete(`/shipments/${shipmentId}/booking`);
      return response;
    },
    onSuccess: () => {
      message.success('Booking removed from shipment');
      queryClient.invalidateQueries({ queryKey: ['contract', reference] });
    },
    onError: (error: any) => {
      message.error(error.response?.data?.error || 'Failed to remove booking');
    },
  });

  // Update contract mutation
  const updateContractMutation = useMutation({
    mutationFn: async ({ contractId, data }: { contractId: string; data: any }) => {
      const response = await api.patch(`/contracts/${contractId}`, data);
      return response;
    },
    onSuccess: () => {
      message.success('Contract updated successfully');
      queryClient.invalidateQueries({ queryKey: ['contract', reference] });
      setEditingContractId(null);
    },
    onError: (error: any) => {
      message.error(error.response?.data?.error || 'Failed to update contract');
      throw error;
    },
  });

  // Update shipment mutation
  const updateShipmentMutation = useMutation({
    mutationFn: async ({ shipmentRef, data }: { shipmentRef: string; data: any }) => {
      const response = await api.patch(`/shipments/${shipmentRef}`, data);
      return response;
    },
    onSuccess: () => {
      message.success('Shipment updated successfully');
      queryClient.invalidateQueries({ queryKey: ['contract', reference] });
      setEditingShipmentId(null);
    },
    onError: (error: any) => {
      message.error(error.response?.data?.error || 'Failed to update shipment');
      throw error;
    },
  });

  const createCustomerInvoiceMutation = useMutation({
    mutationFn: async (shipmentId: string) => {
      return pendingInvoicesApi.createFromShipmentCustomer(shipmentId);
    },
    onSuccess: (data: { pendingInvoiceId: string }) => {
      message.success('Invoice created - redirecting to review...');
      navigate(`/pending-invoices/${data.pendingInvoiceId}`);
    },
    onError: (error: any) => {
      message.error(error.response?.data?.error || 'Failed to create invoice');
    },
  });

  const createCommissionInvoiceMutation = useMutation({
    mutationFn: async (shipmentId: string) => {
      return pendingInvoicesApi.createFromShipmentCommission(shipmentId);
    },
    onSuccess: (data: { pendingInvoiceId: string }) => {
      message.success('Commission invoice created - redirecting to review...');
      navigate(`/pending-invoices/${data.pendingInvoiceId}`);
    },
    onError: (error: any) => {
      if (error.response?.data?.needsCommissionInvoice === false) {
        message.info('This supplier does not require commission invoices');
      } else {
        message.error(error.response?.data?.error || 'Failed to create commission invoice');
      }
    },
  });

  // Booking management handlers
  const handleAddBooking = (shipmentId: string) => {
    setSelectedShipmentId(shipmentId);
    setEditingBookingId(null);
    setEditingBookingData(null);
    setBookingModalOpen(true);
  };

  const handleEditBooking = async (bookingId: string, shipment?: any) => {
    try {
      const bookingData = await api.get(`/bookings/${bookingId}`);
      setEditingBookingId(bookingId);
      setEditingBookingData(bookingData);
      if (shipment) {
        setEditingShipmentData({
          id: shipment.id,
          portDepartureId: shipment.portDepartureId,
          portDepartureCode: shipment.shipmentInfo?.portDepartureCode,
          portArrivalId: shipment.portArrivalId,
          portArrivalCode: shipment.shipmentInfo?.portArrivalCode,
          portIntermediateId: shipment.portIntermediateId,
          portIntermediateCode: shipment.portIntermediateCode,
          packingNotes: shipment.packingNotes,
          sendDocsToId: shipment.sendDocsToId,
        });
      }
      setBookingModalOpen(true);
    } catch (error: any) {
      message.error(error.response?.data?.error || 'Failed to fetch booking data');
    }
  };

  const handleRemoveBooking = (shipmentId: string) => {
    removeBookingMutation.mutate(shipmentId);
  };

  const handleBookingSuccess = (bookingId: string) => {
    setBookingModalOpen(false);
    setSelectedShipmentId(null);
    setEditingBookingId(null);
    setEditingBookingData(null);
    setEditingShipmentData(null);
    queryClient.invalidateQueries({ queryKey: ['contract', reference] });
  };

  const handleFindVessel = (shipment: any) => {
    // Check for existing booking
    const hasExistingBooking = !!(shipment.booking?.vesselVoy || shipment.booking?.bookingNumber);
    
    if (hasExistingBooking) {
      Modal.confirm({
        title: 'Existing Booking Found',
        content: `This shipment already has booking: ${shipment.booking?.vesselVoy || shipment.booking?.bookingNumber}. Continue?`,
        onOk: () => {
          setSelectedShipmentForVessel(shipment);
          setFindVesselModalOpen(true);
        }
      });
    } else {
      setSelectedShipmentForVessel(shipment);
      setFindVesselModalOpen(true);
    }
  };

  // Contract editing handlers
  const handleEditContract = () => {
    setEditingContractId(contract?.id || null);
  };

  const handleSaveContract = async (data: any) => {
    if (!contract?.id) return;
    await updateContractMutation.mutateAsync({ 
      contractId: contract.id, 
      data 
    });
  };

  const handleCancelContractEdit = () => {
    setEditingContractId(null);
  };

  // Shipment editing handlers
  const handleEditShipment = (shipmentId: string) => {
    setEditingShipmentId(shipmentId);
  };

  const handleSaveShipment = async (shipmentRef: string, data: any) => {
    await updateShipmentMutation.mutateAsync({ 
      shipmentRef, 
      data 
    });
  };

  const handleCancelShipmentEdit = () => {
    setEditingShipmentId(null);
  };

  // Handle loading and error states
  if (isLoading) {
    return (
      <div style={{
        background: colors.background.primary,
        minHeight: 'calc(100vh - 112px)',
        padding: spacing['2xl'],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '24px', marginBottom: '16px' }}>Loading contract...</div>
          <div>Please wait while we fetch the contract details.</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        background: colors.background.primary,
        minHeight: 'calc(100vh - 112px)',
        padding: spacing['2xl'],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '24px', marginBottom: '16px', color: colors.status.negative }}>
            Contract Not Found
          </div>
          <div>
            The contract "{reference}" could not be found or you don't have permission to view it.
          </div>
        </div>
      </div>
    );
  }

  if (!contractData) {
    return (
      <div style={{
        background: colors.background.primary,
        minHeight: 'calc(100vh - 112px)',
        padding: spacing['2xl'],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '24px', marginBottom: '16px' }}>No Contract Data</div>
          <div>Unable to load contract data at this time.</div>
        </div>
      </div>
    );
  }

  // Use the loaded contract data
  const contract = contractData;

  /**
   * Generate and preview contract PDF in new tab
   * @param audience - 'seller' or 'buyer' version
   */
  const downloadContractPDF = async (audience: 'seller' | 'buyer') => {
    if (!contract?.id) {
      console.error('No contract ID available for PDF generation');
      return;
    }

    try {
      setDownloadingPDF(audience);

      // Open PDF directly via GET endpoint
      // The backend will stream the PDF with proper Content-Disposition headers
      // This allows the browser to display it with the correct filename
      const pdfUrl = `/api/v1/pdf/contracts/${contract.id}/pdf/${audience}`;

      const newWindow = window.open(pdfUrl, '_blank');

      if (!newWindow) {
        alert('Popup blocked. Please allow popups to preview PDFs.');
      } else {
        const suffix = audience === 'buyer' ? 'b' : 's';
        const filename = `${contract.reference}${suffix}.pdf`;
        console.log(`Successfully opened ${filename} for preview`);
      }
    } catch (error: any) {
      console.error('Failed to open contract PDF:', error);
      alert(error.message || 'Failed to open contract PDF. Please try again.');
    } finally {
      setDownloadingPDF(null);
    }
  };

  /**
   * Generate and preview shipping instruction PDF in new tab
   * @param shipmentId - ID of the shipment to generate SI for
   */
  const downloadSIPDF = async (shipmentId: string) => {
    if (!shipmentId) {
      console.error('No shipment ID available for SI PDF generation');
      return;
    }

    try {
      setDownloadingPDF('si');

      // Open SI PDF directly via GET endpoint
      const pdfUrl = `/api/v1/pdf/shipments/${shipmentId}/si`;

      const newWindow = window.open(pdfUrl, '_blank');

      if (!newWindow) {
        alert('Popup blocked. Please allow popups to preview PDFs.');
      } else {
        console.log('Successfully opened SI PDF for preview');
      }
    } catch (error: any) {
      console.error('Failed to open SI PDF:', error);
      alert(error.message || 'Failed to open SI PDF. Please try again.');
    } finally {
      setDownloadingPDF(null);
    }
  };

  const contractQuickActions: QuickActionButton[] = [
    {
      id: 'supplier-contract',
      text: downloadingPDF === 'seller' ? 'Generating...' : 'Supplier Contract',
      variant: 'positive',
      disabled: downloadingPDF !== null
    },
    {
      id: 'buyer-contract',
      text: downloadingPDF === 'buyer' ? 'Generating...' : 'Buyer Contract',
      variant: 'positive',
      disabled: downloadingPDF !== null
    },
    {
      id: 'manage-shipments',
      text: 'Manage Shipments',
      variant: 'neutral'
    },
    {
      id: 'duplicate-contract',
      text: duplicating ? 'Duplicating...' : 'Duplicate Contract',
      variant: 'neutral',
      disabled: duplicating
    },
    {
      id: 'delete-contract',
      text: deleting ? 'Deleting...' : 'Delete Contract',
      variant: 'negative',
      disabled: deleting
    },
    {
      id: 'empty-1',
      text: '',
      variant: 'disabled',
      disabled: true
    }
  ];

  const getShipmentQuickActions = (shipment: any, pendingInvoiceStatus: any): QuickActionButton[] => {
    const actions: QuickActionButton[] = [];
    
    const hasPendingInvoice = !!pendingInvoiceStatus?.exists;
    const hasDiscrepancy = !!pendingInvoiceStatus?.hasDiscrepancy;
    const invoiceLabel = hasDiscrepancy ? '⚠ Customer Inv.' : 'Customer Inv.';
    actions.push({
      id: hasPendingInvoice ? `view-customer-invoice-${shipment.id}` : `create-customer-invoice-${shipment.id}`,
      text: invoiceLabel,
      variant: hasPendingInvoice ? 'tertiary' : 'positive'
    });
    
    const needsCommission = contract?.parties?.supplier?.needsCommissionInvoice !== false;
    actions.push({
      id: `create-commission-${shipment.id}`,
      text: 'Commission Inv.',
      variant: !needsCommission ? 'disabled' : 'positive',
      disabled: !needsCommission
    });
    
    // Core shipping actions (limited to 4 total to fit 2x3 grid)
    actions.push(
      { id: 'find-vessel', text: 'Find Vessel', variant: 'positive' },
      { id: 'booking-request', text: 'Booking Request', variant: 'positive' },
      { id: 'si-pdf', text: 'SI PDF', variant: 'positive' }
    );
    
    if (actions.length < 6) {
      actions.push({ id: 'si-email', text: 'SI Email', variant: 'positive' });
    }
    
    // Ensure exactly 6 buttons for grid layout
    while (actions.length < 6) {
      actions.push({
        id: `empty-${actions.length}`,
        text: '',
        variant: 'disabled',
        disabled: true
      });
    }
    
    return actions.slice(0, 6); // Ensure max 6 buttons
  };

  const handleQuickActionClick = async (buttonId: string) => {
    console.log('Quick action clicked:', buttonId);

    if (buttonId === 'supplier-contract') {
      setContractEmailAudience('supplier');
      setContractEmailModalOpen(true);
      return;
    }

    if (buttonId === 'buyer-contract') {
      setContractEmailAudience('buyer');
      setContractEmailModalOpen(true);
      return;
    }

    if (buttonId === 'duplicate-contract') {
      if (!contract?.reference) return;
      
      setDuplicating(true);
      try {
        const result = await contractsApi.duplicateContract(contract.reference);
        message.success(`Contract duplicated: ${result.reference}`);
        navigate(`/contracts/${result.reference}/edit`);
      } catch (error: any) {
        console.error('Failed to duplicate contract:', error);
        message.error(error.response?.data?.error || 'Failed to duplicate contract');
      } finally {
        setDuplicating(false);
      }
      return;
    }

    if (buttonId === 'delete-contract') {
      if (!contract?.reference) return;
      
      Modal.confirm({
        title: 'Delete Contract',
        content: `Are you sure you want to delete contract ${contract.reference}? This action cannot be undone.`,
        okText: 'Delete',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk: async () => {
          setDeleting(true);
          try {
            const result: any = await contractsApi.deleteContract(contract.reference);
            if (result.deleted) {
              message.success(`Contract ${contract.reference} permanently deleted`);
            } else if (result.cancelled) {
              message.success(`Contract ${contract.reference} has been cancelled`);
            }
            navigate('/contracts');
          } catch (error: any) {
            console.error('Failed to delete contract:', error);
            message.error(error.response?.data?.error || 'Failed to delete contract');
          } finally {
            setDeleting(false);
          }
        },
      });
      return;
    }

    console.log('Action not yet implemented:', buttonId);
  };

  return (
    <div style={{ 
      padding: spacing.xl,
      backgroundColor: '#FFFFFF',
      minHeight: '100vh'
    }}>
      {/* Page Header */}
      <div style={{ 
        marginBottom: spacing.xl,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Title 
          style={{ 
            color: colors.text.primary,
            marginBottom: 0 
          }}
        >
          {contract.reference}
        </Title>
        <Button 
          icon={<PrinterOutlined />} 
          onClick={() => setPrintModalOpen(true)}
        >
          Print / Export
        </Button>
      </div>

      {/* Contract Section - Two Column Layout */}
      <div style={{ 
        display: 'flex', 
        gap: spacing.xl, 
        alignItems: 'flex-start' 
      }}>
        {/* Primary Column - Contract Details */}
        <div style={{ flex: '1', minWidth: '500px' }}>
          <ContractDetailsCard 
            contract={contract}
            isEditing={editingContractId === contract.id}
            onEditToggle={handleEditContract}
            onSave={handleSaveContract}
            onCancel={handleCancelContractEdit}
          />
        </div>

        {/* Secondary Column - Quick Actions & Commission */}
        <div style={{ 
          width: '500px', 
          display: 'flex', 
          flexDirection: 'column', 
          gap: spacing.xl 
        }}>
          {/* Contract Quick Actions Card */}
          <QuickActionsCard 
            title="Quick Actions"
            buttons={contractQuickActions}
            onButtonClick={handleQuickActionClick}
          />
          
          {/* Contract Commission Card */}
          {contract.contractCommission && (
            <ContractCommissionCard data={contract.contractCommission} />
          )}
        </div>
      </div>

      {/* Shipment Section */}
      {Array.isArray(contract.shipments) && contract.shipments
        .filter(shipment => {
          // If a shipment number is specified in the URL, only show that shipment
          if (shipmentNumber) {
            // Extract the shipment number from the shipment reference (e.g., "CR-CA25479.01" -> "01")
            const shipmentRef = shipment.reference || '';
            const match = shipmentRef.match(/\.(\d{2})$/);
            const currentShipmentNumber = match ? match[1] : null;
            return currentShipmentNumber === shipmentNumber;
          }
          // Otherwise, show all shipments
          return true;
        })
        .map((shipment) => {
        const pendingInvoiceStatus = pendingInvoiceQueries.data?.[shipment.id];
        const shipmentQuickActions = getShipmentQuickActions(shipment, pendingInvoiceStatus);
        
        // Check if this is the selected shipment for auto-scroll
        const shipmentRef = shipment.reference || '';
        const match = shipmentRef.match(/\.(\d{2})$/);
        const currentShipmentNumber = match ? match[1] : null;
        const isSelectedShipment = shipmentNumber && currentShipmentNumber === shipmentNumber;
        
        return (
          <div 
            key={shipment.id} 
            ref={isSelectedShipment ? selectedShipmentRef : null}
            style={{ 
              marginTop: spacing.xl,
              ...(isSelectedShipment && {
                padding: spacing.md,
                borderRadius: '8px',
                border: `2px solid ${colors.primary}`,
                backgroundColor: `${colors.primary}08`, // 8% opacity
                transition: 'all 0.3s ease'
              })
            }}
          >
            {/* Shipment Layout - Two Column */}
            <div style={{ 
              display: 'flex', 
              gap: spacing.xl, 
              alignItems: 'flex-start'
            }}>
              {/* Left Column - Shipment Details */}
              <div style={{ flex: '1', minWidth: '500px' }}>
                <ShipmentDetailsCard 
                  shipment={shipment}
                  isEditing={editingShipmentId === shipment.id}
                  onEditToggle={() => handleEditShipment(shipment.id)}
                  onSave={(data) => handleSaveShipment(shipment.reference || shipment.id, data)}
                  onCancel={handleCancelShipmentEdit}
                />
              </div>

              {/* Right Column - Quick Actions & Booking Details */}
              <div style={{ 
                width: '500px',
                display: 'flex', 
                flexDirection: 'column', 
                gap: spacing.xl 
              }}>
                {/* Shipment Quick Actions Card */}
                <QuickActionsCard
                  title="Quick Actions"
                  buttons={shipmentQuickActions}
                  onButtonClick={(buttonId) => {
                    if (buttonId === 'find-vessel') {
                      handleFindVessel(shipment);
                    } else if (buttonId === 'booking-request') {
                      setSelectedShipmentId(shipment.id);
                      setBookingRequestModalOpen(true);
                    } else if (buttonId === 'si-pdf') {
                      downloadSIPDF(shipment.id);
                    } else if (buttonId === 'si-email') {
                      setSelectedShipmentId(shipment.id);
                      setSiModalOpen(true);
                    } else if (buttonId.startsWith('create-customer-invoice') || buttonId.startsWith('view-customer-invoice')) {
                      if (pendingInvoiceStatus?.status === 'SENT' && pendingInvoiceStatus?.hasDiscrepancy && pendingInvoiceStatus?.pendingInvoiceId) {
                        navigate(`/pending-invoices/${pendingInvoiceStatus.pendingInvoiceId}/reconcile`);
                      } else if (pendingInvoiceStatus?.status === 'SENT' && pendingInvoiceStatus?.xeroInvoiceId) {
                        window.open(`https://go.xero.com/AccountsReceivable/View.aspx?InvoiceID=${pendingInvoiceStatus.xeroInvoiceId}`, '_blank');
                      } else {
                        createCustomerInvoiceMutation.mutate(shipment.id);
                      }
                    } else if (buttonId.startsWith('create-commission') || buttonId.startsWith('view-commission')) {
                      createCommissionInvoiceMutation.mutate(shipment.id);
                    } else {
                      handleQuickActionClick(buttonId);
                    }
                  }}
                />
              
              {/* Booking Details Card - Use shipment-specific docsTo */}
              <BookingDetailsCard
                booking={shipment.booking ? {
                  ...shipment.booking,
                  sendDocsTo: shipment.docsTo || shipment.booking.sendDocsTo || 'N/A'
                } : undefined}
                shipmentId={shipment.id}
                onAdd={() => handleAddBooking(shipment.id)}
                onEdit={() => shipment.booking && handleEditBooking(shipment.booking.id, shipment)}
                onRemove={() => handleRemoveBooking(shipment.id)}
                onFindVessel={() => handleFindVessel(shipment)}
              />

              {/* Payment Tracking Card */}
              <PaymentTrackingCard 
                shipmentId={shipment.id}
                shipmentRef={shipment.reference}
                onTransactionClick={(transaction) => {
                  console.log('Transaction clicked:', transaction);
                }}
              />
            </div>
          </div>

          {/* Container Tracking Card - Full Width */}
          {(() => {
            const trackingData = transformContainerEventsToTrackingData(
              shipment.containers || [],
              { eta: shipment.eta, destinationPort: shipment.destinationPort }
            );
            return trackingData && (
              <div style={{ marginTop: spacing.xl }}>
                <TrackingCard data={trackingData} />
              </div>
            );
          })()}
          
          {/* Two Column Layout - Documents, Financial */}
          <div style={{ 
            display: 'flex', 
            gap: spacing.xl, 
            alignItems: 'flex-start',
            marginTop: spacing.xl
          }}>
            {/* Left Column - Documents */}
            <div style={{ flex: '1' }}>
              {contract.documents && (
                <DocumentsCard 
                  data={contract.documents}
                  onDocumentClick={(doc) => {
                    console.log('Document clicked:', doc);
                  }}
                />
              )}
            </div>

            {/* Right Column - Financial Cards Stacked */}
            <div style={{ 
              width: '500px',
              display: 'flex', 
              flexDirection: 'column', 
              gap: spacing.xl 
            }}>
              {/* Financial Cards with Shared Formatting */}
              {(() => {
                // Create shared formatter for consistent alignment
                const financialFormatter = new FinancialFormatter({
                  commissionData: contract.commission,
                  paymentData: contract.paymentHistory,
                  contractData: contract
                });

                return (
                  <>
                    {/* Commission & Margin Card */}
                    {contract.commission && (
                      <CommissionMarginCard 
                        data={contract.commission} 
                        contract={contract}
                        formatter={financialFormatter}
                        onEditExpenses={(shipmentNumber) => {
                          console.log('Edit expenses for shipment:', shipmentNumber);
                        }}
                      />
                    )}
                  </>
                );
              })()}
            </div>
          </div>
        </div>
      );
      })}

      {/* Message when shipment number specified but not found */}
      {shipmentNumber && Array.isArray(contract.shipments) && 
        contract.shipments.filter(shipment => {
          const shipmentRef = shipment.reference || '';
          const match = shipmentRef.match(/\.(\d{2})$/);
          const currentShipmentNumber = match ? match[1] : null;
          return currentShipmentNumber === shipmentNumber;
        }).length === 0 && (
        <div style={{ 
          marginTop: spacing.xl, 
          padding: spacing.lg, 
          backgroundColor: colors.background.secondary,
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <Typography variant="body1" style={{ color: colors.text.secondary }}>
            Shipment .{shipmentNumber} not found in this contract.{' '}
            <a href={`/contracts/${contractRef}`} style={{ color: colors.primary }}>
              View all shipments
            </a>
          </Typography>
        </div>
      )}

      {/* Booking Request Modal */}
      <BookingRequestModal
        open={bookingRequestModalOpen}
        shipmentId={selectedShipmentId}
        onClose={() => {
          setBookingRequestModalOpen(false);
          setSelectedShipmentId(null);
        }}
      />

      {/* Find Vessel Modal */}
      {selectedShipmentForVessel && (
        <FindVesselModal
          open={findVesselModalOpen}
          onClose={() => {
            setFindVesselModalOpen(false);
            setSelectedShipmentForVessel(null);
          }}
          shipmentId={selectedShipmentForVessel.id}
          initialOrigin={selectedShipmentForVessel.timing?.portDepartureCode}
          initialDestination={selectedShipmentForVessel.timing?.portArrivalCode}
          initialDate={(() => {
            if (!selectedShipmentForVessel.start) return undefined;
            const startDate = new Date(selectedShipmentForVessel.start);
            if (isNaN(startDate.getTime())) return undefined;
            const today = startOfToday();
            const rangeStartMinus7 = subDays(startDate, 7);
            const fromDate = max([rangeStartMinus7, today]);
            return fromDate.toISOString().split('T')[0];
          })()}
          initialWeeks={(() => {
            if (!selectedShipmentForVessel.start || !selectedShipmentForVessel.end) return 4;
            const startDate = new Date(selectedShipmentForVessel.start);
            const endDate = new Date(selectedShipmentForVessel.end);
            if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return 4;
            const fromDate = (() => {
              const today = startOfToday();
              const rangeStartMinus7 = subDays(startDate, 7);
              return max([rangeStartMinus7, today]);
            })();
            
            const daysDiff = differenceInDays(endDate, fromDate);
            const weeksNeeded = Math.ceil(daysDiff / 7);
            return weeksNeeded <= 2 ? 2 : weeksNeeded <= 4 ? 4 : weeksNeeded <= 6 ? 6 : 8;
          })()}
          existingBooking={selectedShipmentForVessel.booking ? {
            id: selectedShipmentForVessel.booking.id,
            vessel: selectedShipmentForVessel.booking.vesselVoy?.split('/')[0]?.trim() || '',
            voyage: selectedShipmentForVessel.booking.vesselVoy?.split('/')[1]?.trim() || '',
            bookingNumber: selectedShipmentForVessel.booking.bookingNumber || ''
          } : undefined}
          onBookingCreated={() => {
            message.success(
              <span>
                Booking created. 
                <Button type="link" size="small" onClick={() => {
                  setFindVesselModalOpen(false);
                  setSelectedShipmentId(selectedShipmentForVessel.id);
                  setBookingRequestModalOpen(true);
                }}>Request Booking</Button>
                <Button type="link" size="small" onClick={() => setFindVesselModalOpen(false)}>Back</Button>
              </span>
            );
            queryClient.invalidateQueries({ queryKey: ['contract', reference] });
          }}
        />
      )}

      {/* Shipping Instruction Modal */}
      <ShippingInstructionModal
        open={siModalOpen}
        shipmentId={selectedShipmentId}
        onClose={() => {
          setSiModalOpen(false);
          setSelectedShipmentId(null);
        }}
      />

      {/* Contract Email Modal */}
      <ContractEmailModal
        open={contractEmailModalOpen}
        contractId={contract.id}
        contractReference={contract.reference}
        audience={contractEmailAudience}
        onClose={() => setContractEmailModalOpen(false)}
        onSuccess={() => {
          console.log('Contract email draft created successfully');
        }}
      />

      {/* Print Modal */}
      <PrintModal
        open={printModalOpen}
        onClose={() => setPrintModalOpen(false)}
        contract={contract}
      />

      {/* Booking Management Modal */}
      <BookingManagementModal
        visible={bookingModalOpen}
        onCancel={() => {
          setBookingModalOpen(false);
          setSelectedShipmentId(null);
          setEditingBookingId(null);
          setEditingBookingData(null);
          setEditingShipmentData(null);
        }}
        onSuccess={handleBookingSuccess}
        shipmentId={selectedShipmentId || undefined}
        editingBooking={editingBookingData}
        shipmentData={editingShipmentData}
      />

    </div>
  );
};

export default ContractReview;